var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlaceDown = function SvgIconPlaceDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconPlaceDown_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.204 7.428h.013a.3.3 0 0 0 .238-.114l2.279-2.216a.285.285 0 0 0 0-.411.305.305 0 0 0-.423 0L5.517 6.43V.721a.297.297 0 0 0-.3-.292c-.165 0-.3.13-.3.291v5.717l-1.8-1.75a.305.305 0 0 0-.423 0 .285.285 0 0 0 0 .411l2.31 2.246a.3.3 0 0 0 .2.084",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.714 8.429h9v1h-9z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconPlaceDown_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.214.429h6v7h-6z"
  })))));
};
export default SvgIconPlaceDown;